export const regionsContextPointSubTypeId = [
    {
        id: 1,
        name: 'Country'
    },
    {
        id: 2,
        name: 'Country' // This is a duplicate entry, consider removing in BED its a HFM country but we are trying to replace it to Country from the UI
    },
    {
        id: 3,
        name: 'Cluster'
    },
    {
        id: 4,
        name: 'Market'
    },
    {
        id: 5,
        name: 'Sub-Region'
    },
    {
        id: 6,
        name: 'Region'
    }
]

export const SalesRegionsContextPointSubTypeId = [
    {
        id: 1,
        name: 'Ecolab Division'
    },
    {
        id: 2,
        name: 'Industrial Division'
    },
    {
        id: 3,
        name: 'SBU'

    },
    {
        id: 4,
        name: 'Sales Region'
    },
    {
        id: 5,
        name: 'District'
    },
    {
        id: 6,
        name: 'Territory'
    },
    {
        id: 7,
        name: 'Sales Group'
    }
]